import { Directive } from '@angular/core';

@Directive({
  selector: 'input',
  host: {
    autocomplete: 'off',
  },
})
export class AutocompleteOffDirective {}
